(function() {
    $(document).ready(function() {
        if (document.querySelector('.vss')) {
            document.addEventListener('c24LpLoginEvent', function(event) {
                if (event.detail && event.detail.type === 'vssLogin') {
                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'vssLogin',
                        'vssLogin',
                    ]);
                }
            });

            const teaserSlides = document.querySelectorAll('.c24-home-slide');
            for (const teaserSlide of teaserSlides) {
                const teaserForm = teaserSlide.querySelector('.c24-yellow-box') || teaserSlide.querySelector('form');
                const teaserFormButton = teaserForm?.querySelector('a') || teaserForm?.querySelector('button');
                if (teaserFormButton) {
                    window.c24Lp.createClickTracking(teaserFormButton, [
                        'prefix',
                        'position',
                        'product',
                        'type',
                    ], 'ppset-teaser', '.fade');
                }
            }

            $('.mod24ComparisonBoxModern > .gridContainer').one('mouseenter', function() {
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'insurance-list:hover',
                ]);
            });

            const fvTileVss = document.querySelector('.fvTileVss');

            if (fvTileVss) {
                $('.fvTileVssButton').one('click', function() {
                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'fv:click',
                    ]);
                });

                $('.fvTileVss').one('mouseenter', function() {
                    window._paq.push([
                        'trackEvent',
                        window.c24Lp.getMatomoEventCategory(),
                        'fv:hover',
                    ]);
                });
            }

            $('.c24-contact-content').one('click', function() {
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'wf:click',
                    'wf:::chatty',
                ]);
            });

            $('.c24-contact-content').one('mouseenter', function() {
                window._paq.push([
                    'trackEvent',
                    window.c24Lp.getMatomoEventCategory(),
                    'wf:hover',
                    'wf:::chatty',
                ]);
            });

            window.c24Lp.createClickTracking('.mod24ComparisonBoxModern > .gridContainer a', ['prefix', 'link'], 'insurance-list');

            const staticSliderNavButtons = document.querySelectorAll('.c24StaticSliderNav');
            if (staticSliderNavButtons.length) {
                staticSliderNavButtons.forEach(function(button) {
                    const action = button.classList.contains('navPrev') ? 'left' : 'right';
                    button.addEventListener('click', function() {
                        window._paq.push([
                            'trackEvent',
                            window.c24Lp.getMatomoEventCategory(),
                            'tile-carousel:click',
                            `tile-carousel:::${action}`,
                        ]);
                    }, {
                        once: true,
                    });
                });
            }
        }
    });
})();
